'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _dark = require('./dark');

var _dark2 = _interopRequireDefault(_dark);

var _light = require('./light');

var _light2 = _interopRequireDefault(_light);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = { dark: _dark2.default, light: _light2.default };